import React, { useState, useEffect } from 'react';
import { summaryAPI } from '../../services/api';

const AdminSummary = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    loadSummary();
  }, []);

  const loadSummary = async () => {
    try {
      const response = await summaryAPI.get();
      setContent(response.data.content || '');
    } catch (error) {
      console.error('Error loading summary:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      await summaryAPI.update(content);
      setMessage('Summary updated successfully!');
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage('Error updating summary');
      console.error('Error updating summary:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2 className="text-gray-800 dark:text-gray-200 text-2xl font-bold mb-4">Professional Summary</h2>
      {message && (
        <div 
          className={`mb-4 p-3 rounded-lg ${
            message.includes('success') 
              ? 'bg-green-100 dark:bg-green-900 text-green-700 dark:text-green-300' 
              : 'bg-red-100 dark:bg-red-900 text-red-700 dark:text-red-300'
          }`}
        >
          {message}
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="text-gray-800 dark:text-gray-200">Summary Content</label>
          <textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            rows="10"
            required
            className="dark:bg-slate-600 dark:text-gray-200 dark:border-slate-500"
          />
        </div>
        <button type="submit" className="btn btn-primary dark:bg-gradient-to-r dark:from-purple-600 dark:to-purple-700" disabled={loading}>
          {loading ? 'Saving...' : 'Save Summary'}
        </button>
      </form>
    </div>
  );
};

export default AdminSummary;

